import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";
import { useLang } from "@/i18n/LanguageContext";
import api from "@/lib/api";

export default function JournalDetail() {
  const { slug } = useParams();
  const { c, lang } = useLang();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/journal/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6">
      <h1 className="font-serif text-4xl">404</h1>
      <Link to="/journal" className="btn-ink">Journal</Link>
    </div>
  );
  if (!post) return <div className="min-h-screen flex items-center justify-center"><span className="font-serif text-2xl animate-pulse">O&rsquo;Lime</span></div>;

  return (
    <div data-testid="journal-detail-page">
      <SEO title={`${post.title} | O'Lime Design`} description={(post.excerpt || "").slice(0, 155)} path={`/journal/${post.slug}`} lang={lang} image={post.image} />
      <PageHeader eyebrow={`${post.category} • ${post.date}`} lines={[post.title]} title={post.title} image={post.image} />
      <section className="py-20 lg:py-28 bg-olime-bg">
        <div className="container-olime max-w-3xl">
          <Reveal>
            <p className="font-serif text-2xl md:text-3xl leading-[1.4] text-olime-ink">{post.excerpt}</p>
            <div className="mt-10 text-olime-muted leading-relaxed whitespace-pre-line text-lg">{post.content}</div>
            <div className="mt-14 pt-10 border-t border-olime-line flex flex-col sm:flex-row sm:items-center gap-6">
              <Link to="/services" data-testid="journal-services-link" className="link-underline text-sm uppercase tracking-[0.2em] text-olime-muted hover:text-olime-ink">{c.nav.services}</Link>
              <Link to="/contact#form" data-testid="journal-contact-cta" className="btn-ink sm:ml-auto">{c.cta.contactCta} <ArrowRight size={14} /></Link>
            </div>
            <Link to="/journal" data-testid="back-to-journal" className="inline-flex items-center gap-2 mt-10 link-underline text-sm uppercase tracking-[0.2em]"><ArrowLeft size={14} /> {c.journal.eyebrow}</Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
